import React from "react";
import { Link } from "react-router-dom";
import {
  FaInstagram,
  FaFacebookF,
  FaTiktok,
} from "react-icons/fa";
import "./Contact.css";

function Contact() {

const handleWhatsAppSubmit = (e) => {
  e.preventDefault();

  const name = e.target.elements["contact-name"].value.trim();
  const email = e.target.elements["contact-email"].value.trim();
  const phone = e.target.elements["contact-phone"].value.trim();
  const subject = e.target.elements["contact-subject"].value.trim();
  const message = e.target.elements["contact-message"].value.trim();

  const whatsappMessage = `TIME VALLEY WATCHES

Dear Time Valley Team,

I am reaching out regarding a personal enquiry and would appreciate your assistance.

CLIENT
Name: ${name}
Email: ${email}
Phone: ${phone || "Not provided"}

ENQUIRY
${subject}

MESSAGE
${message}

I look forward to hearing from you.

Warm regards,
${name}`;

  const whatsappUrl =
    `https://wa.me/923000125398?text=${encodeURIComponent(
      whatsappMessage
    )}`;

  window.open(whatsappUrl, "_blank");
};

  return (
    <main className="tv-contact-page">

      {/* 
          CONTACT HERO
       */}

    <section
  className="tv-contact-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(18, 36, 25, 0.42),
        rgba(18, 36, 25, 0.42)
      ),
      url("/contact10.webp")
    `,
  }}
>

  <div className="tv-contact-hero-glow"></div>

  <div className="tv-contact-hero-container">

    <span className="tv-contact-eyebrow">
      TIME VALLEY WATCHES
    </span>

    <div className="tv-contact-line"></div>

    <h1>
      Let's Talk About
      <br />
      <span>Time.</span>
    </h1>

    <p>
      Whether you have a question about a timepiece,
      need assistance with an order, or simply want to
      know more about Time Valley, we're here to help.
    </p>

  </div>

  <div className="tv-contact-hero-mark">
    CONTACT
  </div>

</section>


      {/* 
          CONTACT INFORMATION + FORM
       */}

      <section className="tv-contact-main">

        <div className="tv-contact-container">

          {/* LEFT SIDE */}

          <div className="tv-contact-info">

            <span className="tv-contact-section-eyebrow">
              GET IN TOUCH
            </span>

            <h2>
              We're Here
              <br />
              <span>For You.</span>
            </h2>

            <p className="tv-contact-intro">
              Our team is always available to assist you with
              product enquiries, orders, collections and any
              other questions you may have.
            </p>


            <div className="tv-contact-details">

              {/* Email */}

              <div className="tv-contact-detail">

                <div className="tv-contact-detail-icon">
                  @
                </div>

                <div>
                  <span>Email</span>
                  <a href="mailto:info@timevalley.com">
                    info@timevalley.com
                  </a>
                </div>

              </div>
                  <div className="tv-contact-detail">

                <div className="tv-contact-detail-icon">
                  TV
                </div>

                <div>
                  <span>Email To Company</span>
                  <a href="mailto:khadamsons786@gmail.com">
                    khadamsons786@gmail.com
                  </a>
                </div>

              </div>


              {/* Phone */}

              <div className="tv-contact-detail">

                <div className="tv-contact-detail-icon">
                  +
                </div>

                <div>
                  <span>Phone</span>
                  <a href="tel:+03249320453">
                    +92 324 9320453
                  </a>
                </div>

              </div>


              {/* Hours */}

              <div className="tv-contact-detail">

                <div className="tv-contact-detail-icon">
                  ◷
                </div>

                <div>
                  <span>Opening Hours</span>
                  <p>
                    Monday — Saturday
                    <br />
                    9:00 AM — 10:00 PM
                  </p>
                </div>

              </div>

            </div>


            {/* SOCIAL */}

<div className="tv-contact-social">

  <span>FOLLOW TIME VALLEY</span>

  <div className="tv-contact-social-links">

    <a
      href="https://www.instagram.com/time._valley/"
      aria-label="Instagram"
    >
      <FaInstagram />
    </a>

    <a
      href="https://www.facebook.com/share/1LqZQxKVar/"
      aria-label="Facebook"
    >
      <FaFacebookF />
    </a>

    <a
      href="https://www.tiktok.com/@time._valley?_r=1&_t=ZP-9AFBmFcFtVv"
      aria-label="TikTok"
    >
      <FaTiktok />
    </a>
  </div>

</div>


          </div>


          {/* RIGHT SIDE FORM */}

          <div className="tv-contact-form-wrapper">

            <div className="tv-contact-form-heading">

              <span>CONTACT US</span>

              <h2>
                Send Us A
                <br />
                <em>Message.</em>
              </h2>

            </div>


<form
  className="tv-contact-form"
  onSubmit={handleWhatsAppSubmit}
>


              <div className="tv-contact-form-row">

                <div className="tv-contact-field">
                  <label htmlFor="contact-name">
                    Your Name
                  </label>

                  <input
                    id="contact-name"
                    type="text"
                    placeholder="Enter your name"
                    required
                  />
                </div>


                <div className="tv-contact-field">
                  <label htmlFor="contact-email">
                    Email Address
                  </label>

                  <input
                    id="contact-email"
                    type="email"
                    placeholder="Enter your email"
                    required
                  />
                </div>

              </div>


              <div className="tv-contact-field">

                <label htmlFor="contact-phone">
                  Phone Number
                </label>

                <input
                  id="contact-phone"
                  type="tel"
                  placeholder="Enter your phone number"
                />

              </div>


              <div className="tv-contact-field">

                <label htmlFor="contact-subject">
                  Subject
                </label>

                <input
                  id="contact-subject"
                  type="text"
                  placeholder="How can we help?"
                  required
                />

              </div>


              <div className="tv-contact-field">

                <label htmlFor="contact-message">
                  Your Message
                </label>

                <textarea
                  id="contact-message"
                  rows="6"
                  placeholder="Tell us how we can assist you..."
                  required
                ></textarea>

              </div>


              <button
                type="submit"
                className="tv-contact-submit"
              >
                Send Message
                <span>→</span>
              </button>

            </form>

          </div>

        </div>

      </section>


      {/* 
          VISIT US
       */}

      <section className="tv-contact-visit">

        <div className="tv-contact-visit-container">

          <div className="tv-contact-visit-content">

            <span className="tv-contact-section-eyebrow">
              VISIT TIME VALLEY
            </span>

            <h2>
              Experience Time
              <br />
              <span>In Person.</span>
            </h2>

            <p>
              Discover our collections up close and experience
              the details, materials and craftsmanship that
              define Time Valley.
            </p>

            <Link
              to="/shop"
              className="tv-contact-visit-button"
            >
              Explore Our Watches
              <span>→</span>
            </Link>

          </div>


          <div className="tv-contact-visit-card">

  <span className="tv-contact-location-number">
    01
  </span>

  <span className="tv-contact-location-label">
    TIME VALLEY
  </span>

  <h3>
    Our
    <br />
    <span>Location</span>
  </h3>

  <p>
    MM Alam Road,
    <br />
    Gulberg III, Lahore,
    <br />
    Punjab, Pakistan
  </p>

 <a
  href="https://www.google.com/maps/search/?api=1&query=Allama+Iqbal+Town+Lahore+Pakistan"
  target="_blank"
  rel="noopener noreferrer"
>
  Get Directions
  <span>→</span>
</a>

</div>

        </div>

      </section>

    </main>
  );
}

export default Contact;